import * as shape from "d3-shape";
import BaseChart from "./BaseChart";

class LineChart extends BaseChart {
  static defaultProps = {
    ...BaseChart.defaultProps,
  };

  createPaths({ data, x, y }: any) {
    const { curve } = this.props;

    const line = shape
      .line()
      .x((d: any) => x(d.x))
      .y((d: any) => y(d.y))
      .defined((item: any) => typeof item.y === "number")
      .curve(curve)(data);

    return {
      path: line,
      line,
    };
  }
}

export default LineChart;
